import Toast from "components/common/Toast";
import { AnimatePresence } from "framer-motion";
import useToast from "hooks/common/useToast";

const ToastRouter = () => {
  const { toasts } = useToast();

  // mode="wait" 옵션을 사용하면 토스트가 사라질 때 애니메이션이 완료될 때까지 기다림
  return (
    <AnimatePresence mode="wait">
      {toasts.map((toast) => (
        <Toast key={toast.id} id={toast.id} toast={toast} />
      ))}
    </AnimatePresence>
  );
};

export default ToastRouter;